<ng-container [ngSwitch]="props.entityType">
  <ng-container *ngSwitchCase="'quoteV2'">
    <ng-container *ngIf="isQuote(entity)">
      <lui-avatar
        *ngrxLet="
          entity.workflowStatus
            | workflowMeta : entity.type : entity.portalId as workflowMeta
        "
        [size]="props.size"
        [matTooltip]="workflowMeta.label"
        [color]="workflowMeta.level | infoLevelColor"
      >
        <mat-icon [svgIcon]="workflowMeta.icon"></mat-icon>
      </lui-avatar>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'quote'">
    <lui-avatar
      *ngIf="isQuote(entity)"
      [size]="props.size"
      [color]="entity.status | quoteStatusColor"
      [matTooltip]="entity.status | quoteStatusDescription"
    >
      <mat-icon [svgIcon]="entity.status | quoteStatusIcon"></mat-icon>
    </lui-avatar>
  </ng-container>
  <ng-container *ngSwitchCase="'policy'">
    <ng-container *ngIf="isPolicy(entity)">
      <lui-avatar
        *ngrxLet="
          entity.status | policyStatusMeta : entity.portalId as policyStatusMeta
        "
        [size]="props.size"
        [matTooltip]="policyStatusMeta.label"
      >
        <mat-icon [svgIcon]="policyStatusMeta.icon"></mat-icon>
      </lui-avatar>
    </ng-container>
  </ng-container>
</ng-container>
